import { bl_fi_internal_purchase_credit_note_import_file_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class PurchaseCreditNoteFileImportContainerModel extends BaseContainerModel {
    bl_fi_internal_purchase_credit_note_import_file_hdr: bl_fi_internal_purchase_credit_note_import_file_hdr_RowClass = new bl_fi_internal_purchase_credit_note_import_file_hdr_RowClass();
}